import { extendTheme, ThemeConfig } from "@chakra-ui/react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { light } from "./colors";
import bgray from "./colors/bgray";
import primary from "./colors/primary";
import Alert from "./components/alert";
import Button from "./components/button";
import Checkbox from "./components/checkbox";
import Table from "./components/table";
import semanticTokens from "./semanticTokens";

export const colors = {
  primary,
  bgray,
  brand: {
    // primary: "#7630EC",
    // primaryLight: "#F7F1FF",
    // primaryText: "#7630EC",
    background: "#F0F1F5",
    backgroundLight: "#ffffff",
    textBg: "#F0F1F5",
    textColor: "#000000",
    textLight: "#ffffff",
    disabledText: "#8C8C8C",
    textInactive: "#8C8C8C",
    separator: "#A9A9A9",
    errorColor: "#FF002E",
    social: {
      text: "#718096",
      icon: "#718096",
    },
    sideNavFooter: {
      text: "#718096",
      hover: "#000",
    },
    defiPreview: {
      text: "#38A169",
      bg: "#F0FFF4",
    },
    alert: {
      infoColor: "#000",
      infoBgColor: "#EBF8FF",
      infoIconColor: "#3182CE",
      errorColor: "#000",
      errorBgColor: "#FFF5F5",
      errorIconColor: "#E53E3E",
      warningColor: "#000",
      warningBgColor: "#FFFFF0",
      warningIconColor: "#ECC94B",
    },
    auditedBy: {
      boderColor: "#EEEFF4",
    },
    banner: {
      text: "#FFF",
      background: "#3182CE",
      dangerBackground: "#E53E3E",
    },
    modalOverlay: "#303347CC",
    ...light.brand,
  },
};

export const styles = {
  global: () => ({
    body: {
      bg: "brand.background",
      color: "brand.textColor",
    },
  }),
};

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  fonts: {
    body: `"IBM Plex Sans", Montserrat, -apple-system, BlinkMacSystemFont, Roboto, sans-serif;`,
    heading: `"IBM Plex Sans", Montserrat, -apple-system, BlinkMacSystemFont, Roboto, sans-serif;`,
    mono: `"IBM Plex Sans", Montserrat, -apple-system, BlinkMacSystemFont, Roboto, sans-serif;`,
  },
  colors,
  styles,
  components: {
    Alert,
    Checkbox,
    Button,
    Table,
  },
  semanticTokens,
});

export default theme;
